module.exports = __webpack_public_path__ + "img/communication.2925a1b6.jpg";